module.exports = __webpack_public_path__ + "static/img/12.a339ca6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/sp/12.png
// module id = DWlt
// module chunks = 0